// © Microsoft Corporation. All rights reserved.

import { BridgeEventNames, dispatchBridgeEvent } from "../Social.bridge";

import { enums } from "./enums";
import { getExternalURL } from "./urlHelper";
import { hasThemeBase } from "./themeHelpers";

export default function openEditProfilePage(theme, market, target = "_self") {
    const url = getExternalURL(enums.externalUrls.profileSettings, market);
    const isSuperApp = hasThemeBase(theme, enums.theme.superappBase);
    if (isSuperApp) {
        dispatchBridgeEvent(BridgeEventNames.requestBrowser, {url: url});
    } else {
        window.open(url, target);
    }
}